import { render, staticRenderFns } from "./mobNews.vue?vue&type=template&id=dac8a39c&scoped=true&"
import script from "./mobNews.vue?vue&type=script&lang=js&"
export * from "./mobNews.vue?vue&type=script&lang=js&"
import style0 from "./mobNews.vue?vue&type=style&index=0&id=dac8a39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac8a39c",
  null
  
)

export default component.exports